import { StorageLocationTableRowSchema } from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getStorageLocationById = {
  name: "getStorageLocationById" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    includeZeroQuantity: z.boolean().optional(),
  }),
  output: z.object({
    storageLocation: StorageLocationTableRowSchema.nullable(),
  }),
};
